import React from "react";
import HeaderSearch from "../../../../common/components/HeaderSearch";
import GetCompensationContextProvider, {
  ACTIONS,
  GetCompensationContext,
} from "../../context/GetCompensationContextProvider";
import Loading from "../../../../common/components/Loading";
import AlertMessage from "../../../../common/components/AlertMessage";
import { CGE } from "../../../../common/components/CGE";

const GetReliquidationPriv = ({
  titleReliquidation,
  description,
  textFetchError,
  textAlertFilledField,
  textFetchNoId,
  setGlobalAlert
}) => {
  const [loading, setLoading] = React.useState(true);
  const [state, dispatch] = React.useContext(GetCompensationContext);
  const [inputSearch, setInputSearch] = React.useState("");
  const [inputSelected, setInputSelected] = React.useState("");
  const [decretoSelected, setDecretoSelected] = React.useState("");
  const [decretoLabelSelected, setLabelDecretoSelected] = React.useState("");
  const [errorToggle, setErrorToggle] = React.useState(false);
  const [listOptionReliquidation, setListOptionReliquidation] = React.useState([]);
  let data = state.idList ? state.idList : [];
  let listCartolaReliquidation = state.listCartolaReliquidation ? state.listCartolaReliquidation : []

  function handleChange(e) {
    setDecretoSelected(e.target.value);
    setLabelDecretoSelected(e.target.options[e.target.options.selectedIndex].innerText);
  }

  function handleClickButton() {
    if (inputSelected && decretoSelected) {
      setErrorToggle(false)
      setLoading(true);
      dispatch({
        payload: [inputSelected, decretoSelected, decretoLabelSelected],
        type: ACTIONS.SET_CURRENT_ARRAY,
      })
    } else {
      dispatch({
        payload: [],
        type: ACTIONS.SET_CURRENT_ARRAY,
      })
      setGlobalAlert(textAlertFilledField, "warning");
      setErrorToggle(true)
      if(!inputSelected) {
        setGlobalAlert("Debes ingresar un Nro. de Cliente", "warning");
      }
    }
  }

  React.useEffect(() => {
    setLoading(true);
    dispatch({
      payload: true,
      type: ACTIONS.SET_LOAD_PAGE,
    });
  }, []);

  React.useEffect(() => {
    if (inputSearch !== "") {
      if (data.find((o) => o === inputSearch)) {
        setInputSelected(inputSearch);
        document.getElementById("mySelectId").value = inputSearch;
      } else {
        dispatch({
          payload: "",
          type: ACTIONS.SET_IDCLIENT,
        });
        setInputSelected("");
        document.getElementById("mySelectId").value = "";
      }
    }
  }, [inputSearch]);

  React.useEffect(() => {
    if (inputSelected) {
      dispatch({
        payload: inputSelected,
        type: ACTIONS.SET_IDCLIENT,
      });
      setInputSearch("");
    } else {
      setInputSelected("");

      document.getElementById("mySelectId").value = "";
      dispatch({
        payload: "",
        type: ACTIONS.SET_IDCLIENT,
      });
    }
  }, [inputSelected]);

  React.useEffect(() => {
    if (Object.keys(state.responseReliquidation)?.length !== 0 || state.responseReliquidation?.byteLength || state.errorFetch !== null) {
      setLoading(false);
    }
  }, [state.responseReliquidation, state.errorFetch]);

  React.useEffect(() => {
    if (state.listCartolaReliquidation) {
      let listOptionReliquidationAux = [];
      listOptionReliquidationAux.push({ label: "Seleccione", value: "" })
      listCartolaReliquidation.detalle?.items.map((obj) => {
        listOptionReliquidationAux.push({ label: obj['TEXTEXP'], value: obj['IDRELIQ'] })
        setLoading(false);
        if (!decretoSelected) {
          setDecretoSelected(listOptionReliquidationAux[0].value);
          setLabelDecretoSelected(listOptionReliquidationAux[0].label);
        }

      });
      setListOptionReliquidation(listOptionReliquidationAux);
    }

  }, [state.listCartolaReliquidation]);

  React.useEffect(() => {
    if (state.responseReliquidation?.status === 500) {
      setGlobalAlert(textFetchError, "warning", true, "Advertencia");
    } else if (state.responseReliquidation?.message) {
      setGlobalAlert(state.responseReliquidation?.message, "warning", true, "Advertencia");
    }
  }, [state.responseReliquidation]);

  return (
    <>
      <HeaderSearch
        data={data}
        setSearch={setInputSearch}
        setSelected={setInputSelected}
        idClient={inputSelected}
        inputSearch={inputSearch}
      />
      <CGE.Panel title={titleReliquidation}>
        <div className="d-flex align-items-center flex-column mb-4">
          <CGE.PanelContainer
            alingItensCenter={true}
            size="md"
          >
            <CGE.FormsField
              handleChange={(e) => handleChange(e)}
              horizontal={true}
              idFormElement="mySelectYear"
              labelName="Decreto de Reliquidación:"
              labelStyle={{ width: '215px' }}
              listOptions={listOptionReliquidation}
              mandatoryElement={true}
              style={{ background: '#fff' }}
              typeElement="select"
              typeFormElement="text"
              hasError={errorToggle && !decretoSelected }
              msgError="Debes seleccionar un decreto de reliquidación."
            />
          </CGE.PanelContainer>
          <CGE.Button
            label="Generar Cartola"
            onClick={() => handleClickButton()}
            type="primary"
          />
        </div>
        {loading && <Loading />}
      </CGE.Panel>
    </>
  );
};

const GetCompensationWithProvider = ({
  titleReliquidation,
  description,
  qtdRowPage,
  textFetchError,
  textLoadingBoleta,
  textFetchNoId,
  textAlertExcel,
  textAlertFilledField,
  setGlobalAlert
}) => (
  <GetCompensationContextProvider>
    <GetReliquidationPriv
      titleReliquidation={titleReliquidation}
      description={description}
      qtdRowPage={qtdRowPage}
      textFetchError={textFetchError}
      textLoadingBoleta={textLoadingBoleta}
      textFetchNoId={textFetchNoId}
      textAlertExcel={textAlertExcel}
      textAlertFilledField={textAlertFilledField}
      setGlobalAlert={setGlobalAlert}
    />
  </GetCompensationContextProvider>
);
export default GetCompensationWithProvider;
